import { BASE_CONTEXT_V2_ROLEPLAY } from "../api-context";

export const SKILL_GENERATION = {
    SKILL_GENERATE: `${BASE_CONTEXT_V2_ROLEPLAY}generate_evaluation_skills`,
    CREATE: `${BASE_CONTEXT_V2_ROLEPLAY}create_skill_generation`,
    LIST: (business_unit_code: string, region_code: string) => `${BASE_CONTEXT_V2_ROLEPLAY}list_skill_generations?business_unit_code=${business_unit_code}&region_code=${region_code}`,
    BY_ID: (skill_generation_id: string | number) => `${BASE_CONTEXT_V2_ROLEPLAY}get_skill_generation/${skill_generation_id}`,
    UPDATE: (skill_generation_id: string | number) => `${BASE_CONTEXT_V2_ROLEPLAY}update_skill_generation/${skill_generation_id}`,
    WITH_SUBSKILLS: (skill_name: string) => `${BASE_CONTEXT_V2_ROLEPLAY}get_skill_with_subskills?skill_name=${encodeURIComponent(skill_name)}`,
    // ALL_SKILLS: (business_unit_code: string) => `${BASE_CONTEXT_V2_ROLEPLAY}list_evaluation_skills/${business_unit_code}`
    ALL_SKILLS: (business_unit_code: string) => `${BASE_CONTEXT_V2_ROLEPLAY}all-skills?business_unit_code=${business_unit_code}`
}
